import { createFileRoute } from "@tanstack/react-router";

import { SignIn } from "@/features/marketing/SignIn";

export interface SignInSearch {
  readonly error?: string;
  readonly provider?: string;
}

/** What the callback landed with, so one failure can be said once and named where it is useful. */
function validateSearch(search: Record<string, unknown>): SignInSearch {
  const out: { error?: string; provider?: string } = {};
  if (typeof search["error"] === "string") out.error = search["error"];
  if (typeof search["provider"] === "string") out.provider = search["provider"];
  return out;
}

export const Route = createFileRoute("/sign-in")({
  component: SignIn,
  validateSearch,
});
